import { render, staticRenderFns } from "./DealArrangementOptions.vue?vue&type=template&id=2b296bda&"
import script from "./DealArrangementOptions.vue?vue&type=script&lang=ts&"
export * from "./DealArrangementOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b296bda')) {
      api.createRecord('2b296bda', component.options)
    } else {
      api.reload('2b296bda', component.options)
    }
    module.hot.accept("./DealArrangementOptions.vue?vue&type=template&id=2b296bda&", function () {
      api.rerender('2b296bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/DealArrangementOptions.vue"
export default component.exports